var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"animated-decimal-number"},[_c('animated-number',{attrs:{"value":_vm.integerPart}}),_c('span',{staticClass:"decimal"},[_vm._v("."),_c('animated-number',{attrs:{"value":_vm.decimalPart}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }